<template>
  <div class="bottom clearfix">
    <el-row :gutter="5">
      <el-col :lg="8">
        <PagePagination :total="total" @fetch="fetch" />
      </el-col>
      <el-col :lg="8" style="margin-top: 2px; float: right">
        <!-- PageExportOptions @export="exportData" /-->
      </el-col>
    </el-row>
  </div>
</template>
<script>
import PagePagination from "../PagePagination";
import PageExportOptions from "../PageExportOptions";

export default {
  name: 'PostSroMainTableHeader',
  props: ["total"],
  components: {
    PagePagination,
    PageExportOptions,
  },
  methods: {
    fetch(records, page) {
      this.$emit("fetch", records, page);
    },
    exportData(type) {
      this.$emit("export", type);
    }
  }
}
</script>